import React from 'react'

import ReportSelectionList from 'components/reporting/ReportSelectionList'

function ReportSelection() {
  return <ReportSelectionList />
}

export default ReportSelection
